import React from 'react';
import styled from 'styled-components';

interface SpacerProps {
  height: string;
}

const SpacerArea = styled.div<SpacerProps>(({ height }) => ({
  height: height,
}));

const Spacer: React.FC<SpacerProps> = ({ height }) => {
  return <SpacerArea height={height} />;
};

export default Spacer;
